import * as TYPES from './types';
import { permissionMenuGroupState } from './selector';

const initialState = {
  permissions: [],
};

const permission = (state = initialState, action) => {
  if (!Object.keys(TYPES).includes(action.type)) return state;
  const permissionGroup = permissionMenuGroupState({ permission: state });
  const { menu } = action.payload;
  const permissions = permissionGroup[menu] || [];
  const handleEquals = item => {
    const conditions = [];
    Object.keys(action.payload).forEach(key => {
      const payloadValue = action.payload[key];
      const itemValue = item[key];
      if (payloadValue) conditions.push(itemValue === payloadValue);
    });
    return conditions.every(v => v);
  };
  switch (action.type) {
    case TYPES.PUSH_PERMISSION:
      // 已存在权限不再添加
      if (permissions.some(handleEquals)) return state;
      state.permissions.push({
        ...action.payload,
        _index: state.permissions.length,
      });
      return state;
    case TYPES.REMOVE_PERMISSION:
      var permission = permissions.find(handleEquals);
      if (permission) state.permissions.splice(permission._index, 1);
      return state;
    case TYPES.CLEAR_PERMISSION:
      if (action.payload) {
        state.permissions = state.permissions.filter(
          item => !handleEquals(item)
        );
      } else state.permissions = [];
      return state;
  }
};

export default permission;
